import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";

// views
import Worker from "views/admin/Worker.js";
import Leads from "views/admin/Leads.js";
import Chats from "views/admin/Chats.js";
import History from "components/History/History";

export default function Admin() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Routes>
            <Route path="Worker" element={<Worker />} />
            <Route path="Leads" element={<Leads />} />
            <Route path="Chats" element={<Chats />} />
            <Route path="History" element={<History/>} />
            <Route path="*" element={<Navigate to="Worker" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
